import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';

import { Button } from 'components/Buttons';

import { ImageWrapper } from './TextWithImage.styles';

import { colors } from 'styles';
import { IApplicationTextImageData } from 'types/applications';
import { useIsMobile } from 'hooks/useIsMobile';

interface TextWithImageProps extends IApplicationTextImageData {
  type?: 'default' | 'customer-case';
}

const TextWithImage: FC<TextWithImageProps> = ({
  imageSrc,
  type = 'default',
  description,
  title,
  link,
  listItems,
}) => {
  const navigate = useNavigate();
  const isDefault = type === 'default';
  const isMobile = useIsMobile();

  return (
    <Box display="flex" justifyContent="center">
      <Box
        display="flex"
        alignItems="center"
        maxWidth={1200}
        width="100%"
        padding={{
          '834px': '0px',
        }}
        gap={{
          md: '80px',
          xxs: '36px',
        }}
        flexDirection={{
          md: 'row',
          sm: isDefault ? 'row' : 'column',
          xxs: 'column',
        }}
        justifyContent={{
          md: 'space-between',
          sm: isDefault ? 'space-between' : 'center',
          xxs: 'inherit',
        }}
      >
        <ImageWrapper>
          <img src={imageSrc} alt="application" />
        </ImageWrapper>

        <Box
          maxWidth={{
            lg: '560px',
            md: '420px',
            sm: isDefault ? '361px' : '100%',
            xxs: '100%',
          }}
          sx={{
            '@media (min-width: 1024px)': {
              order: -1,
            },
          }}
        >
          <Typography
            component="h3"
            fontSize={{
              md: '40px',
              xxs: '32px',
            }}
            color={colors.mainDark}
            fontWeight={700}
            lineHeight="120%"
            marginBottom="24px"
            maxWidth={{
              lg: '560px',
              md: '420px',
              sm: isDefault ? '361px' : '100%',
              xxs: '100%',
            }}
          >
            {title}
          </Typography>

          <Typography color={colors.mainDark} fontSize="18px">
            {description}
          </Typography>

          {isDefault && listItems && (
            <>
              <Typography
                marginTop="32px"
                marginBottom="16px"
                color={colors.mainDark}
                fontWeight={700}
                lineHeight="140%"
                fontSize="20px"
              >
                Key Challenges:
              </Typography>

              <ul style={{ margin: 0, padding: 0, paddingLeft: '20px' }}>
                {listItems.map((i) => (
                  <li
                    key={i}
                    style={{
                      color: colors.mainDark,
                      lineHeight: '150%',
                    }}
                  >
                    {i}
                  </li>
                ))}
              </ul>
            </>
          )}

          {!isDefault && (
            <Box marginTop="24px">
              <Button
                width={isMobile ? 'full' : 234}
                onClick={() => {
                  if (link) {
                    navigate(link);
                  }
                }}
              >
                View Customer Case
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TextWithImage;
